import { HomeFloorAIcon } from './HomeFloorAIcon';

/**
 * author: GreenTurtwig
 * id 5A227D09-2828-4606-81B8-7622D7C8724C
 * name home-floor-a
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-floor-a.svg
 * tags
 * - Home Automation 
 */
export const HomeFloorAtticIcon = HomeFloorAIcon;
export default HomeFloorAtticIcon